export default __webpack_public_path__ + "static/media/service2.4bccd3d7.jpg";